<svg display="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <symbol viewBox="0 0 188 32" id="forticloud--logo">
        <path
            d="M51.37,20.56s0-.1,0-.12v-.12l0-.11a10,10,0,0,0-6.07-7.45A15.57,15.57,0,0,0,45,10.13a12,12,0,0,0-4.37-7,13.28,13.28,0,0,0-10.82-3h0A13.39,13.39,0,0,0,20.65,6a9.44,9.44,0,0,0-3.43.24A10.08,10.08,0,0,0,10.13,12c-.84.08-1.77.18-2.62.34l-.08,0a10.12,10.12,0,0,0-6.35,5.18,9.6,9.6,0,0,0-.5,7.71,10.3,10.3,0,0,0,9.9,6.8h.76V29.74h-.76a8.09,8.09,0,0,1-7.8-5.33,7.3,7.3,0,0,1,.4-5.89A7.81,7.81,0,0,1,8,14.5c.8-.15,1.68-.23,2.53-.32h.14A1.46,1.46,0,0,0,12,13.24l0-.07a7.91,7.91,0,0,1,5.7-4.72,7.24,7.24,0,0,1,2.82-.18,1.55,1.55,0,0,0,1.75-.71A11.23,11.23,0,0,1,30.1,2.4a11,11,0,0,1,9.06,2.51l.05,0a9.68,9.68,0,0,1,3.56,5.67A13.63,13.63,0,0,1,43,13.23v.18l.08.25a1.55,1.55,0,0,0,1,1.07,7.85,7.85,0,0,1,5,5.85,2.34,2.34,0,0,0,.07.45,1,1,0,0,0,0,.12v1.63a13,13,0,0,1-.4,1.75,7.93,7.93,0,0,1-5.22,4.83V31.7a10.16,10.16,0,0,0,7.33-6.4l0-.08a15.31,15.31,0,0,0,.5-2.23V21.15a3,3,0,0,0-.07-.59">
        </path>
        <rect style="fill: #3080e3;" x="15.55" y="21.53" width="6.58" height="4.34"></rect>
        <rect style="fill: #3080e3;" x="23.92" y="15.25" width="6.73" height="4.4"></rect>
        <rect style="fill: #3080e3;" x="23.92" y="27.73" width="6.73" height="4.26"></rect>
        <rect style="fill: #3080e3;" x="32.45" y="21.53" width="6.58" height="4.34"></rect>
        <g>
            <path style="fill: #3080e3;"
                d="M39,28.19A4.17,4.17,0,0,1,36.52,32H32.38V27.73H39ZM22.2,32H18.06a4.2,4.2,0,0,1-2.51-3.81v-.44H22.2ZM15.55,19.22a4.54,4.54,0,0,1,2.66-4h4v4.42H15.55Zm16.83-4h4a4.53,4.53,0,0,1,2.67,4v.44H32.38Z">
            </path>
            <path style="fill: #3080e3;" d="M22.13,15.25H18.19a4.47,4.47,0,0,0-2.64,3.91v.43h6.58Z"></path>
            <path style="fill: #3080e3;" d="M15.55,28.26A4.11,4.11,0,0,0,18,32h4.1V27.81H15.55Z"></path>
            <path style="fill: #3080e3;" d="M39,19.15a4.46,4.46,0,0,0-2.64-3.9H32.45v4.34H39Z"></path>
            <path style="fill: #3080e3;" d="M32.45,32h4.09A4.12,4.12,0,0,0,39,28.25v-.44H32.45Z"></path>
        </g>
        <g>
            <polygon
                points="60.94 6.8 73.63 6.8 73.63 10.14 64.99 10.14 64.99 14.71 72.78 14.71 72.78 18.05 64.99 18.05 64.99 25.96 60.94 25.96 60.94 6.8">
            </polygon>
            <g>
                <path
                    d="M84.63,18.81c0-2.51-1-4.36-3-4.36s-3,1.85-3,4.36,1,4.35,3,4.35,3-1.85,3-4.35m-10.09,0c0-4.46,2.71-7.43,7.07-7.43s7.07,3,7.07,7.43-2.71,7.4-7.07,7.4-7.07-3-7.07-7.4">
                </path>
                <path
                    d="M90.75,11.62h3.86v2.5h.15a3.5,3.5,0,0,1,3.45-2.71,6.31,6.31,0,0,1,1.26.14v3.54a6.86,6.86,0,0,0-1.69-.22,2.9,2.9,0,0,0-3,3V26h-4Z">
                </path>
                <path
                    d="M109.2,14.61h-2.71v7c0,1.1.56,1.4,1.35,1.4a5.08,5.08,0,0,0,1-.13l.63,3a7.52,7.52,0,0,1-2.16.37c-2.89.13-4.81-1.27-4.79-4.08V14.61h-2v-3h2V8.17h4v3.45h2.71Z">
                </path>
                <path d="M110.76,11.62h4V26h-4Zm-.15-3.88a2.17,2.17,0,0,1,4.32,0,2.16,2.16,0,0,1-4.32,0"></path>
                <path
                    d="M130.2,13.54a3.87,3.87,0,0,0-4.12-3.39c-3,0-4.91,2.27-4.91,6.26s2,6.26,4.88,6.26a3.91,3.91,0,0,0,4.15-3.23l4.1,0c-.44,3.52-3.4,6.79-8.32,6.79-5.12,0-8.92-3.59-8.92-9.84s3.86-9.84,8.92-9.84c4.44,0,7.79,2.54,8.32,7Z">
                </path>
            </g>
            <rect x="136.6" y="6.83" width="3.99" height="19.16"></rect>
            <path
                d="M152.75,18.83c0-2.51-1-4.36-3-4.36s-3,1.85-3,4.36,1,4.35,3,4.35,3-1.84,3-4.35m-10.1,0c0-4.45,2.72-7.43,7.08-7.43s7.07,3,7.07,7.43-2.71,7.41-7.07,7.41-7.08-3-7.08-7.41">
            </path>
            <path
                d="M168.08,11.62h4V26h-3.82V23.38h-.15a4.42,4.42,0,0,1-4.36,2.79c-2.89,0-4.86-2-4.87-5.4V11.62h4v8.44a2.46,2.46,0,0,0,2.49,2.75,2.71,2.71,0,0,0,2.74-2.94Z">
            </path>
            <path
                d="M184.11,18.8c0-2.56-1.09-4.2-3-4.2s-3,1.71-3,4.2,1.07,4.25,3,4.25,3-1.68,3-4.25m-10.12,0c0-4.94,2.67-7.39,5.82-7.39A4.23,4.23,0,0,1,183.9,14H184V6.83h4V26h-3.93v-2.3h-.17a4.25,4.25,0,0,1-4.08,2.53c-3.27,0-5.83-2.59-5.83-7.4">
            </path>
        </g>
    </symbol>
</svg>

<div class="main">
    <div class="left-side">
        <div class="login-section">
            <div class="header">
                <div class="logo">
                    <a href="https://forticloud.com" target="_blank" rel="noopener noreferrer">
                        <svg>
                            <use xlink:href="#forticloud--logo"></use>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="details">
                <a [routerLink]="['/']">
                    <div class="logo">
                    </div>
                </a>
                <div class="title">
                    <span class="text">FortiSIEM Cloud</span>
                </div>
                <div class="login-buttons">
                    <button class="login" (click)="redirectToLogin()">
                        <span class="text">Login</span>
                    </button>
                    <button class="register" (click)="redirectToRegister()">
                        <span class="text">Register</span>
                    </button>
                </div>
                <div class="description">
                    <div>FortiSIEM brings together visibility, correlation, analytics, UEBA, discovery and reporting
                        into
                        a single solution.</div>
                    <br />
                    <div>It reduces the complexity of managing network and security operations to effectively free
                        resources, improve incident detection, and even prevent breaches.</div>
                    <div>
                        <a target="_blank" href="https://docs.fortinet.com/product/fortisiem-cloud">Discover
                            more &gt;</a>
                    </div>
                </div>


            </div>
        </div>
        <a target="_blank" href="https://www.fortinet.com/" class="land-fortinet-logo"></a>
        <div class="land-version">{{version}}</div>
    </div>
    <div class="right-side">
        <div class="splash-content">
            <div class="information">
                <div class="big">Next-Generation SIEM Capabilities</div>
                <div class="small">More than just aggregate security events, FortiSIEM Cloud<br />offers leading
                    threat
                    protection and high business value</div>
                <div class="middle">
                    <div class="normal">
                        <span>
                            Scale FortiSIEM Cloud as you grow
                        </span>
                    </div>
                    <div class="normal">
                        <span>
                            Enterprise and Multi-Tenant (MSSP) support
                        </span>
                    </div>
                    <div class="normal">
                        <span>
                            Platform management by Fortinet
                        </span>
                    </div>
                    <div class="normal">
                        <span>
                            Focus on incident detection and management
                        </span>
                    </div>
                </div>
            </div>


        </div>
        <div class="land-foot">
            <span>Copyright &copy; {{ currentYear }} Fortinet, Inc. All Rights Reserved.</span>
            <span><a target="_blank" href="https://www.fortinet.com/corporate/about-us/legal"
                    rel="noopener noreferrer">Terms of Service</a></span>
            <span>|</span>
            <span><a target="_blank" href="https://www.fortinet.com/corporate/about-us/privacy.html"
                    rel="noopener noreferrer">Privacy Policy</a></span>
        </div>
    </div>
</div>
